import NiceModal from "@ebay/nice-modal-react";

import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import ModalBase from "modals/base/ModalBase";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./Modal.module.css";
import P from "components/P";
import Center from "layouts/wrapper/Center";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import qrIcon from "resources/dummy/qrcode222.png";
import liquidIcom from "resources/dummy/소다 1.png";
import closeIcon from "resources/dummy/Group 62.png";
import Inline from "layouts/container/Inline";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { QRCodeSVG } from "qrcode.react";
import favicon from "resources/img/favicon.ico";
// import { HOST } from "routes/front/main/WebSocketContainer";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "components/buttons/CustomButton";

import { requester } from "App";
import { toast } from "react-toastify";
import { CollectionsBookmark } from "@mui/icons-material";
import { AuthContext } from "providers/AuthProvider";
import ProcessBar from "routes/front/main/vending/mainPage/ProcessBar";
import { decode } from "shared/utils/Utils";
// import paymentSound from "resources/music/paymentSound.mp3";

const TestPuffuOrderModal = NiceModal.create(props => {
  const { t } = useTranslation();
  const [withHeader, withFooter] = [false, false];
  const [width, height] = ["80%", "45%"];
  const withCloseButton = true;
  const modal = useRef();
  const clickOutsideToClose = true;
  const title = t("");
  const buttonText = t("close");
  const dispatch = useDispatch();
  const cartData = useSelector((state) => state.cart.products);
  const [cartList, setCartList] = useState([]);
  const [total, setTotal] = useState(0);
  const [timer, setTimer] = useState(60 * 3); // 3분 타이머
  const [paymentResult, setPaymentResult] = useState();
  const [machineData, setMachineData] = useState();
  const countdownInterval = useRef(null);
  const showTimer = timer <= 60;
  const { id } = useParams();
  // 원의 둘레 계산
  const radius = 20; // 원의 반지름
  const circumference = 2 * Math.PI * radius;
  // 시간이 감소함에 따라 strokeDashoffset을 감소시켜 원이 점점 비워지는 효과
  // strokeDashoffset을 계산하여 원이 점점 줄어드는 효과를 만듭니다.
  // 타이머가 줄어들 때 원의 둘레에 비례하여 strokeDashoffset 값이 감소합니다.
  const strokeDashoffset = showTimer ? (1 - timer / 60) * circumference : circumference;
  const navigate = useNavigate();
  // const audioRef = useRef();

  useEffect(() => {
    window.addEventListener("showWaitingModal", () => {
      NiceModal.show("addressKr")
    });
    window.addEventListener("closeWaitingModal", () => {
      NiceModal.show("addressKr")
    });

    return () => {
      window.removeEventListener("showWaitingModal", () => { });
      window.removeEventListener("closeWaitingModal", () => { });
      // audioRef.current.play();
    };
  }, []);

  useEffect(() => {
    if (timer > 60) return; // 60초 이상이면 타이머 작동하지 않음

    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
      if (timer === 0) {
        clearInterval(interval);
        modal.current.close(); // 모달 닫기
        navigate(`/ws/${props.id}/home`); // 홈으로 이동
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [timer, modal, navigate, props.id]);

  // 타이머 시각적 표현
  // 타이머가 60초 미만일 때만 표시




  const PaymentQR = () => {
    
    const extractedData = cartList.map(item => ({
      locationNo: item.locationNo,
      quantity: item.quantity,

    }));
    const extractedValues = extractedData.map(item => [item.locationNo, item.quantity]);

    const trxId = paymentResult && paymentResult.link.trxId;
    const trackId = paymentResult && paymentResult.link.trackId; //purchaseorder Id
    const amount = paymentResult && paymentResult.link.amount; // amount 
    const storeCode = paymentResult && paymentResult.link.udf1;
    const deviceCode = window.BRIDGE && window.BRIDGE.getDeviceCode ? window.BRIDGE.getDeviceCode() : "";






    // const processedCartData = cartData.map(product => {
    //   const filteredProduct = {};

    //   Object.entries(product).forEach(([key, value]) => {
    //     if (!key.endsWith('Img') && value !== null) {
    //       filteredProduct[key] = value;
    //     }
    //   });

    //   return filteredProduct;
    // });
    

    const jsonData = extractedValues;

    const jsonString = JSON.stringify(jsonData);
    const base64EncodedString = btoa(jsonString);
    const param = `data=${base64EncodedString}`;

    return (
      <QRCodeSVG

        value={`${id}/vendingSignIn?deviceCode=${deviceCode}`}

        size={"20vw"}
        bgColor={"#ffffff"}
        // bgColor={"#fe5b35"}
        fgColor={"#000000"}
        level={"L"}
        includeMargin={false}
      // imageSettings={{
      //   src: favicon,
      //   x: undefined,
      //   y: undefined,
      //   height: 48,
      //   width: 48,
      //   excavate: true,
      // }}
      />
    );
  }

  const SignUpQR = () => {
    return (
      <QRCodeSVG
        // value={`${window.location.origin}/ws/${props.id}/signUp`}
        value={`${window.location.origin}/appRedirect`}
        // value={"puffu://MainScreen"}
        size={"20vw"}
        bgColor={"#ffffff"}
        // bgColor={"#fe5b35"}
        fgColor={"#000000"}
        level={"L"}
        includeMargin={false}
      // imageSettings={{
      //   src: favicon,
      //   x: undefined,
      //   y: undefined,
      //   height: 48,
      //   width: 48,
      //   excavate: true,
      // }}
      />
    );
  }



  const Product = (props) => {
    const { data } = props;
    const deleteCartProductClick = () => {
      dispatch(CartReducer.actions.removeProductFromCart(data));
    }
    return (
      <VerticalFlex>
        <FlexChild width={"95%"} padding={"10px 0"}>
          <HorizontalFlex gap={10}>
            <FlexChild width={"20%"}>
              <img src={data.productImg} width={"100%"} />
            </FlexChild>
            <FlexChild justifyContent={"flex-end"} width={40}>
              <img src={closeIcon} style={{ width: "100%" }} onClick={deleteCartProductClick} />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
        {
          props.line
            ?
            null
            :
            <FlexChild>
              <div
                style={{
                  width: "100%",
                  height: "1px",
                  backgroundColor: "#757575",
                }}
              />
            </FlexChild>
        }

      </VerticalFlex>

    );
  }



  return (
    <ModalBase
      ref={modal}
      width={width}
      height={height}
      withHeader={withHeader}
      withFooter={withFooter}
      withCloseButton={withCloseButton}
      clickOutsideToClose={clickOutsideToClose}
      title={title}
      buttonText={buttonText}
      overflow={"visible"}
      // borderRadius={"25px"}
      onClose={props.onClose}
    >
      {/* <audio ref={audioRef} src={paymentSound} preload="auto" /> */}
      {/* <div style={{padding: "5vw"}}> */}
      <VerticalFlex padding={"4vw"} gap={10}>
        {/* <div style={{ width: "100%", height: "2px", backgroundColor: "black" }} /> */}
        <FlexChild height={"max-content"}>
          <P size={40} font={"Pretendard"} weight={900}>푸푸오더</P>
        </FlexChild>
        <FlexChild width={"max-content"}>
          <PaymentQR />
        </FlexChild>
      </VerticalFlex>
      {/* </div> */}
    </ModalBase>
  );
});

export default TestPuffuOrderModal;
